import React from 'react';
import PropTypes from 'prop-types';
import EditorStandartLayout from '../../editor/components/controls/EditorStandartLayout';
import { TemplateChangerButtons } from '../../editor/components/controls/TemplateChanger';

import PickerMenu from '../components/PickerMenu';
import WidgetListPanel from '../components/WidgetListPanel';

const WidgetPicker = ({
    wide = true,
    tab,
    params = {},
    onWidgetSelected = () => {},
    template,
    onTabOpen,
    onTemplateChanged = () => {},
}) => {
    return (
        <EditorStandartLayout>
            <PickerMenu
                tab={tab}
                params={params}
                template={template}
                onTabOpen={onTabOpen}
                onTemplateChanged={onTemplateChanged}
            />

            {template ? (
                <WidgetListPanel
                    wide={wide}
                    tab={tab}
                    params={params}
                    template={template}
                    onTabOpen={onTabOpen}
                    onWidgetSelected={onWidgetSelected}
                />
            ) : (
                <div>
                    <TemplateChangerButtons template={template} onTemplateChanged={onTemplateChanged} />
                </div>
            )}
        </EditorStandartLayout>
    );
};

WidgetPicker.propTypes = {
    onTemplateChanged: PropTypes.func.isRequired,
    onTabOpen: PropTypes.func.isRequired,
    onWidgetSelected: PropTypes.func.isRequired,
    tab: PropTypes.string.isRequired,
    template: PropTypes.string.isRequired,
};

//

export default WidgetPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/components/WidgetPicker.js
 **/